import type { ReactNode } from 'react';

/**
 * A KPI tile is a number that triggers an action, not a vanity metric — so every
 * one carries the action it drives. `hint` is where the honesty goes: how many
 * materials had no price, how old the oldest pending item is.
 */
export default function Tile({
  label, value, hint, tone = 'neutral', action,
}: {
  label: string;
  value: ReactNode;
  hint?: ReactNode;
  tone?: 'neutral' | 'good' | 'warn' | 'bad';
  action?: ReactNode;
}) {
  return (
    <div className={`tile card tile--${tone}`}>
      <div className="tile__label">{label}</div>
      <div className="tile__value mono-num">{value}</div>
      {hint && <div className="tile__hint muted">{hint}</div>}
      {action && <div className="tile__action">{action}</div>}
    </div>
  );
}
